import Settings from './Settings.vue'
import List from './List.vue'
import New from './New.vue'
import Edit from './Edit.vue'
import Delete from './Delete.vue'
import { Route } from 'vue-router'

export const All = [Settings, List, New, Edit, Delete]

export default {
  Settings,
  List,
  New,
  Edit,
  Delete
}

export const RouteConfig = [
  {
    path: 'teams',
    component: Settings,
    name: 'settings-teams',
    children: [
      {
        path: 'list',
        component: List,
        name: 'settings-teams-list',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':teamId/edit/',
        component: Edit,
        name: 'settings-teams-edit',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            teamId: route?.params?.teamId
          }
        }
      },
      {
        path: 'new',
        component: New,
        name: 'settings-teams-new',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      },
      {
        path: ':teamId/delete',
        component: Delete,
        name: 'settings-teams-delete',
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId,
            teamId: route?.params?.teamId
          }
        }
      },
      {
        path: '',
        component: Settings,
        props: function(route: Route) {
          return {
            clientId: route?.params?.clientId
          }
        }
      }
    ]
  }
]
